export default (parentElement, options) => {
    const element = document.createElement('link');
    element.rel = options.type;
    element.href = options.href;
    parentElement.appendChild(element);
    return element;
};